export const POPULARITY = 'POPULARITY';
export const SHOPS = 'SHOPS';
export const CATEGORIES = 'CATEGORIES';


// WEBPACK FOOTER //
// ./constants/listTypes.js